/*
import {
  ht,
  cr,
  a,
  gs,
  ls,
  BoxC,
  BtnC,
  GridC,
  LblC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as icm from './icm';
import * as icvBaseS10Rz from './icvBaseS10Rz';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  const _frcUdt = ls.frcUdt();

  const _sPz = ls.usePz({
    steps: [0],
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _frcUdt,
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      sPz: _sPz,
      cz: {
        pageName: 'メニュー',
      },
      oClds: [
        cr.c(BoxC.N, {
          key: -10,
          boxStlz: a(`dw/120 f/1 fd/ccc`),
          oClds: [

            cr.c(LblC.N, {
              key: -10,
              abtType: 'barHdrCmnz',
              boxStlz: a(`mb/4`),
              lblCz: {
                boxStlz: a(`mb/4`),
                textz: {
                  pfx: 'システム設定'
                }
              },
              cttCz: {
                oClds: [
                  cr.c(GridC.N, {
                    key: -10,
                    abtType: 'nolineCmnz',
                    lineCs: [
                      {
                        cellCs: [
                          {
                            boxStlz: a(`fd/ccc mb/4`),
                            oClds: [
                              icm.chkPmn('2z211') ?
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                lblCz: {
                                  textz: {
                                    pfx: '休館日'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icv_61S10Rz',
                                    });
                                  }
                                },
                              })
                              : undefined
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc mb/4`),
                            oClds: [
/*
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                lblCz: {
                                  textz: {
                                    pfx: '市連携パスワード'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                  }
                                },
                              })
*/
                            ],
                          },
                          {
                            boxStlz: a(`fd/ccc mb/4`),
                            oClds: [
                              cr.c(BtnC.N, {
                                key: -10,
                                abtType: 'homeStfz',
                                lblCz: {
                                  textz: {
                                    pfx: '他設定項目'
                                  },
                                },
                                pslPtyz: {
                                  onPress: () => {
                                    cr.moveTo({
                                      pageName: 'icvHomeS40Rz',
                                    });
                                  }
                                },
                              })
                            ],
                          },
                        ]
                      },
                    ]
                  }),
                ]
              }
            }),

          ]
        })
      ]
    })
  );
};
